import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const DollarIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      opacity="0.5"
      fill={color}
      d="M4.60417 14.4444H5.52951V13.1862C7.89931 13.0226 9.2309 11.6233 9.2309 9.86285C9.2309 7.69618 7.17708 6.99653 5.9809 6.68056L5.52951 6.55642V2.54471C6.72569 2.66319 7.59462 3.30642 7.71875 4.33333H9.07292C9.01649 2.68576 7.57205 1.43316 5.52951 1.29774V-4.27468e-07H4.60417V1.31467C2.66884 1.51215 1.21875 2.74219 1.21875 4.51389C1.21875 6.07118 2.34722 6.99653 4.15278 7.51562L4.60417 7.6454V11.9167C3.41927 11.7925 2.44878 11.1832 2.34722 10.0208H0.902778C1.03255 11.7982 2.38672 13.0395 4.60417 13.1862V14.4444ZM5.52951 11.9167V7.91059L5.57465 7.92188C6.7934 8.26042 7.87674 8.68924 7.87674 9.84028C7.87674 10.9744 6.89497 11.7643 5.52951 11.9167ZM4.60417 6.30816C3.74653 6.06554 2.57292 5.59158 2.57292 4.44618C2.57292 3.47005 3.36285 2.72526 4.60417 2.56163V6.30816Z"
    />
  </svg>
);

DollarIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

DollarIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(10, 15),
};

export default DollarIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/dollar.js